import { render } from "./XIconSolidBot.vue?vue&type=template&id=ea9dfa64"
import script from "./XIconSolidBot.vue?vue&type=script&lang=js"
export * from "./XIconSolidBot.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidBot.vue"]])

export default __exports__